// src/components/PopupMessage.js
import React from 'react';

const PopupMessage = ({ message, type, onClose }) => {
  if (!message) return null;

  const styles = {
    popup: {
      position: 'fixed',
      top: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '1rem 2rem',
      borderRadius: '8px',
      color: 'white',
      backgroundColor: type === 'success' ? '#28a745' : '#dc3545', // Your logic is perfect here
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      display: 'flex',
      alignItems: 'center',
      zIndex: 1000,
    },
    // ✅ STYLE CHANGE: Added styles for the message text
    messageText: {
        margin: 0, // Removes default paragraph margin for better alignment
        padding: 0,
    },
    closeBtn: {
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '1.5rem',
      // ✅ LAYOUT CHANGE: Using marginRight to add space on the correct side
      marginRight: '1rem',
      cursor: 'pointer',
    }
  };

  return (
    <div style={styles.popup}>
      {/* ✅ LAYOUT CHANGE: Swapped order for a more standard UI (message first, then button) */}
      <p style={styles.messageText}>{message}</p>
      <button style={styles.closeBtn} onClick={onClose}>×</button>
    </div>
  );
};

export default PopupMessage;